import * as actions from '../../actions/actionTypes';

const initialState = 10;

export default function size(state = initialState, action) {
  switch (action.type) {
    case actions.SET_FEEDS_HISTORY:
      return action.payload.rowPerPage;
    default:
      return state;
  }
}
